import { z } from 'zod';
import { id, coords, constrainedStrings } from './common';

// Rectangle style type
export type RectangleStyle = typeof rectangleStyleOptions[number];
// Define rectangle style options (similar to connector styles)
export const rectangleStyleOptions = ['SOLID', 'DOTTED', 'DASHED'] as const;
export const rectangleLabelPositionOptions = [
  'CENTER',
  'TOP_LEFT',
  'TOP_RIGHT',
  'BOTTOM_LEFT',
  'BOTTOM_RIGHT'
] as const;
export type RectangleLabelPosition = typeof rectangleLabelPositionOptions[number];

export const rectangleSchema = z.object({
  id,
  color: id.optional(),
  from: coords,
  to: coords,
  // New styling properties
  description: constrainedStrings.description.optional(),
  opacity: z.number().min(0).max(1).optional(),
  borderWidth: z.number().min(0).optional(),
  borderStyle: z.enum(rectangleStyleOptions).optional(),
  borderColor: id.optional(), // References a color ID
  cornerRadius: z.number().min(0).optional(),
  fill: z.boolean().optional(),
  labelPosition: z.enum(rectangleLabelPositionOptions).optional(),
  // Layer properties
  visible: z.boolean().optional(),
  locked: z.boolean().optional(),
  zIndex: z.number().optional()
});

// export type RectangleSchemaType = z.infer<typeof rectangleSchema>;